import axios from 'axios';

// Always use /api for the preview/production environment
// This works because Kubernetes ingress routes /api requests to the backend
const API_URL = '/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('cyberbank_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('cyberbank_token');
      localStorage.removeItem('cyberbank_user');
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (username, password) => api.post('/auth/login', { username, password }),
  register: (userData) => api.post('/auth/register', userData),
  getMe: () => api.get('/auth/me'),
};

export const accountAPI = {
  getAccounts: () => api.get('/accounts'),
  getAccount: (id) => api.get(`/accounts/${id}`),
  createAccount: (data) => api.post('/accounts', data),
};

export const transferAPI = {
  createTransfer: (data) => api.post('/transfers', data),
  getTransactions: (skip = 0, limit = 50) => api.get(`/transactions?skip=${skip}&limit=${limit}`),
  getTransaction: (id) => api.get(`/transactions/${id}`),
};

export const dashboardAPI = {
  getStats: () => api.get('/dashboard/stats'),
};

export const adminAPI = {
  getAllUsers: () => api.get('/admin/users'),
  deleteUser: (id) => api.delete(`/admin/users/${id}`),
  getAllAccounts: () => api.get('/admin/all-accounts'),
  getUserAccounts: (userId) => api.get(`/admin/users/${userId}/accounts`),
  createUserAccount: (userId, data) => api.post(`/admin/users/${userId}/accounts`, data),
  updateAccountBalance: (accountId, data) => api.put(`/admin/accounts/${accountId}/balance`, data),
  getAllTransactions: (skip = 0, limit = 100) => api.get(`/admin/all-transactions?skip=${skip}&limit=${limit}`),
  approveTransaction: (transactionId, data) => api.put(`/admin/transactions/${transactionId}/approve`, data),
};

export default api;